module.exports = __webpack_public_path__ + "img/XLM.3fbaf18b.svg";